import React from 'react';

import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';

import Text from '~components/atoms/Text';

import Table from '~components/molecules/Table';

import combinedActions from '~redux/combinedActions';

import { useAppDispatch, useAppSelector } from '~redux/hooks';

import { TUpdateTransactionStatusReduxParams } from '~types/feat/approval';

import { TransactionActionEnum, TransactionStatusEnum } from '~utils/enums';

import UtilFunctions from '~utils/functions';

import * as Styles from './_ConfirmCancelTransactionPendingModal.module.scss';

const ConfirmCancelTransactionPendingModal = () => {
    const { 
        Misc: { dateTimeFormat }
    } = UtilFunctions;

    const isOpen = useAppSelector(state => state.gold.modals.confirmUpdateCancelTransactionModalIsOpen);

    const tempUpdateTransactionState = useAppSelector(state => state.gold.tempUpdateTransactionState);

    const isLoading = useAppSelector(state => state.gold.loadings.updateTransactionStatus);
    const error = useAppSelector(state => state.gold.errors.updateTransactionStatus);

    const cancelAffectedTransactionDetails = useAppSelector(state => state.gold.buyAndSellGold.cancelAffectedTransaction);

    const getStatus = () => {
        switch (tempUpdateTransactionState.status) {
            case (TransactionStatusEnum.Cancelled): return 'Confirm';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.goldSetConfirmUpdateCancelTransactionModalIsOpen(open));

    const updateTransactionStatus = (data: TUpdateTransactionStatusReduxParams) => dispatch(combinedActions.goldUpdateTransactionStatusAttempt(data));

    const handleSubmitClick = () => {
        updateTransactionStatus({
            ...tempUpdateTransactionState,
            confirmAutoRejectPendingTransactions: true,
        });
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Confirm' ? Styles['confirm-cancel'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.goldResetUpdateTransactionStatusState());
        }

        setIsOpen(false);
    };

    const tableHeader = [
        'TRANSACTION ID',
        'TRANSACTION TYPE',
        'BRANCH CODE',
        'BRANCH NAME',
        'CUSTOMER NAME',
        'TRANSACTION DATE',
    ];

    const tableBody = cancelAffectedTransactionDetails?.data?.map(transaction => [
        transaction.transactionId,
        transaction.action === TransactionActionEnum['Bank Buy'] ? 'Buy Gold' : 'Sell Gold',
        transaction.branchCode,
        transaction.branchName,
        transaction.customerName,
        dateTimeFormat(transaction.transactionDate),
    ]) || [];

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Transaction cannot be cancelled.`}
        >
            <div className={Styles['title-text']}>
                <Text
                    label='The serial number is currently in use by another transaction.'
                    isBold
                />
            </div>

            {/* <Text
                label='Reject these pending approval transaction(s) to proceed:'
                isBold
            /> */}
            {/* <Table
                header={tableHeader}
                body={tableBody}
            /> */}

            <div className={Styles['button-container']}>
                {/* <ActionButton
                    testId='transaction-cancelTransaction-modal-cancel-button'
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                /> */}

                <ActionButton
                    testId='transaction-update-status-cancelTransaction-modal-button'
                    label='Close'
                    onClick={handleOnModalClose}
                    isLoading={isLoading}
                    // className={Styles['close-button']}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmCancelTransactionPendingModal;
